module.exports = __webpack_public_path__ + "static/media/image73.1d271bbb.png";